import { Component, elements as $$, isValidJson } from '@contorion/core';

export abstract class ClassManipulatorComponent extends Component {

    // valid target can be array string: '["target1", "target2"]'
    // or single string: "target1"
    protected get targetSelector(): string {
        return this.element.dataset.target;
    }

    // transfer it to boolean
    protected get targetPreventDefault(): boolean {
        return (this.element.dataset.preventDefault ?? 'true') === 'true';
    }

    protected get targets(): Array<HTMLElement> {
        return isValidJson(this.targetSelector) ?
            JSON.parse(this.targetSelector)
                .map((target: string) => $$<HTMLElement>(target))
                .flat()
            :
            $$<HTMLElement>(this.targetSelector);
    }

    protected get eventListenerTypes(): Array<string> {
        if (!this.element.dataset.eventListenerTypes) {
            return ['click'];
        }

        return JSON.parse(this.element.dataset.eventListenerTypes);
    }

    protected constructor(protected element: HTMLElement) {
        super(element);

        for (const eventListenerType of this.eventListenerTypes) {
            this.element.addEventListener(eventListenerType, this.onEvent.bind(this));
        }
    }

    public abstract manipulateClasses(): void;

    protected onEvent(e: Event): void {
        if (this.targetPreventDefault) {
            e.preventDefault();
        }

        this.manipulateClasses();
    }
}
